<template>
  <div class="login-state w-floating">
    <transition name="van-slide-up">
      <div class="login-menu">
        <img
          v-if="showAdEntra"
          class="img-meet-ad"
          @click="openAd()"
          src="../../assets/images/icon-ad.png"
          alt=""
        />
      </div>
    </transition>

    <template v-if="false">
      <transition name="van-slide-up">
        <div
          class="login-menu logged-in button shadow"
          v-show="loginIsShow && userInfo.isLogin && loginButtonShow"
        >
          <span class="user-name" @click="toUserCenter">{{
            userInfo && userInfo.userName ? userInfo.userName : ""
          }}</span>
          <span class="icontemp logout-a u-logout" @click="logout"></span>
        </div>
      </transition>

      <div v-if="tenantPermInfo && tenantPermInfo.isDisabledVoteQueDown == 2">
        <transition name="van-slide-up">
          <div
            class="wap-share-box"
            v-show="loginIsShow && webinarInfo.posterStatus == '1'"
          >
            <span
              class="icon icontemp shaerd i-shared-wap"
              @click="gotoPoster()"
            ></span>
          </div>
        </transition>
        <transition name="van-slide-up">
          <div
            class="login-menu"
            v-show="loginIsShow"
            v-if="template.meeting.interact_file_icon.display.value"
          >
            <span class="icontemp form i-more" @click="showFile"></span>
          </div>
        </transition>
        <transition name="van-slide-up">
          <div
            class="login-menu"
            v-show="loginIsShow"
            v-if="template.meeting.interact_vote_icon.display.value"
          >
            <span class="icontemp storied i-more" @click="getVote"></span>
          </div>
        </transition>
        <transition name="van-slide-up">
          <div
            class="login-menu"
            v-show="loginIsShow"
            v-if="template.meeting.interact_question_icon.display.value"
          >
            <span class="icontemp volume i-more" @click="questionary"></span>
          </div>
        </transition>
        <transition name="van-slide-up">
          <div
            class="login-menu"
            v-show="loginIsShow"
            v-if="template.meeting.interact_luckdraw_icon.display.value"
          >
            <span
              class="icontemp lottery i-more"
              @click="getLuckyDrawRoster()"
            ></span>
          </div>
        </transition>
      </div>

      <div class="login-menu" v-show="loginMenuIsShow">
        <span class="icontemp more i-more" @click="toggle()"></span>
      </div>
    </template>

    <div :class="['m-new-floating', { close: !loginIsShow }]">
      <div class="m-floating-btn" @click="toggle()">
        <img
          :src="
            loginIsShow
              ? require('../../assets/images/floating/close.png')
              : require('../../assets/images/floating/open.png')
          "
          alt="btn"
        />
      </div>
      <div class="m-floating-content">
        <template
          v-if="tenantPermInfo && tenantPermInfo.isDisabledVoteQueDown == 2"
        >
          <div
            class="w-floating-item"
            v-if="template.meeting.interact_question_icon.display.value"
          >
            <!-- 调查问卷 -->
            <img
              @click="questionary()"
              :src="require('../../assets/images/floating/questionary.png')"
              alt="question"
            />
          </div>
          <div
            class="w-floating-item"
            v-if="template.meeting.interact_vote_icon.display.value"
          >
            <!-- 投票 -->
            <img
              @click="getVote()"
              :src="require('../../assets/images/floating/vote.png')"
              alt="vote"
            />
          </div>
          <div
            class="w-floating-item"
            v-if="template.meeting.interact_luckdraw_icon.display.value"
          >
            <!-- 幸运抽奖 -->
            <img
              @click="getLuckyDrawRoster()"
              :src="require('../../assets/images/floating/gift.png')"
              alt="luckyDraw"
            />
          </div>
          <div
            class="w-floating-item"
            v-if="template.meeting.interact_file_icon.display.value"
          >
            <!-- 文件下载 -->
            <img
              @click="showFile()"
              :src="require('../../assets/images/floating/file.png')"
              alt="file"
            />
          </div>
          <div class="w-floating-item" v-show="webinarInfo.posterStatus == '1'">
            <!-- 分享 -->
            <img
              @click="gotoPoster()"
              :src="require('../../assets/images/floating/share.png')"
              alt="poster"
            />
          </div>
          <div
            class="w-floating-item"
            v-show="userInfo.isLogin && loginButtonShow"
            @click="toUserCenter()"
          >
            <!-- 个人中心 -->
            <img
              :src="require('../../assets/images/floating/center.png')"
              alt="poster"
            />
            <div class="user-name">
              {{
                userInfo && userInfo.userName ? userInfo.userName : "个人中心"
              }}
            </div>
          </div>
          <div
            class="w-floating-item"
            v-show="userInfo.isLogin && loginButtonShow"
          >
            <!-- 退出登录 -->
            <img
              @click="logout()"
              :src="require('../../assets/images/floating/user.png')"
              alt="poster"
            />
          </div>
          <div class="c-floating-item2">
            <!-- 返回顶部 -->
            <img
              @click="scrollTop"
              :src="require('../../assets/images/floating/top.png')"
              alt="top"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { $subscriber, ck, cr } from "fire-wind-water";
import URL from "../../assets/conf/setting.json";
import { mixinsTemplate } from "../../common/mixinsTemplate";
import { logout } from "../../common/joinMeeting";
export default {
  name: "Interaction",
  mixins: [mixinsTemplate],
  data() {
    return {
      loginIsShow: true,
      userInfo: null,
      webinarInfo: {},
      loginMenuIsShow: true,
      loginButtonShow: true,
      isMeetingInfo:
        window.location.href.indexOf("meetingInfo") > -1 ? true : false,
      showAd: false,
      showAdEntra: false
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.isLogin = false;
      this.loginMenuIsShow = true;
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
      });
      $subscriber.subscribe("setUserName", data => {
        const userInfo = window.$sk.webinar.get().user;
        this.userInfo = userInfo;
      });
      debugger;
      if (this.webinarInfo.needLogin === false) {
        this.loginButtonShow = false;
      }
      if (this.webinarInfo.posterShareUrl) {
        const userInfo = window.$sk.webinar.get().user;
        this.webinarInfo.posterShareUrl = this.webinarInfo.posterShareUrl.replace(
          "#/",
          "&markCode=" + userInfo.markCode + "#/"
        );
      }

      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
        if (
          data.markCode &&
          data.markCode !== "" &&
          this.webinarInfo.posterShareUrl &&
          this.webinarInfo.posterShareUrl.indexOf("markCode") == -1
        ) {
          this.webinarInfo.posterShareUrl = this.webinarInfo.posterShareUrl.replace(
            "#/",
            "&markCode=" + data.markCode + "#/"
          );
        }

        this.showAdEntra = false;
        if (this.webinarInfo.adList) {
          cr.each(this.webinarInfo.adList, item => {
            if (
              item.adDevice == "wap" &&
              this.pctemplate.meeting &&
              ((item.adType == "2" &&
                item.adContent &&
                this.pctemplate.meeting.ad.display.value) ||
                (item.adType == "1" &&
                  this.pctemplate.meeting.adimage.display.value))
            ) {
              this.showAdEntra = true;
            }
          });
        }

        //处理隐藏设置按钮
        //1 总控开 单独控制
        if (
          (this.tenantPermInfo.isDisabledVoteQueDown != 2 ||
            (!this.template.meeting.interact_file_icon.display.value &&
              !this.template.meeting.interact_vote_icon.display.value &&
              !this.template.meeting.interact_question_icon.display.value &&
              !this.template.meeting.interact_luckdraw_icon.display.value)) &&
          !this.userInfo.isLogin
        ) {
          this.loginMenuIsShow = false;
        }
      });

      $subscriber.subscribe("hideWapshowAd", data => {
        this.showAd = false;
        if (!ck.cookie("user_ad_" + data.id)) {
          ck.cookie("user_ad_" + data.id, "1", {
            expires: 1,
            domain: window.$sk.config.domain,
            path: "/"
          });
        }
      });
    },
    toggle() {
      this.loginIsShow = !this.loginIsShow;
    },
    getLuckyDrawRoster() {
      $subscriber.emit("getLuckyDrawRoster");
    },
    showFile() {
      $subscriber.emit("showFile");
    },
    logout() {
      this.isLogin = false;
      return logout(this.webinarInfo);
    },
    //海报
    gotoPoster() {
      const userInfo = window.$sk.webinar.get().user;
      if (userInfo.markCode) {
        this.webinarInfo.posterShareUrl = this.webinarInfo.posterShareUrl.replace(
          "#/",
          "&markCode=" + userInfo.markCode + "#/"
        );
      }
      window.$sk.goto(this.webinarInfo.posterShareUrl, true).subscribe(res => {
        window.open(res);
      });
    },
    getVote() {
      $subscriber.emit("clickOnVote", "shoudong");
    },
    toUserCenter() {
      window.$sk
        .goto(
          URL.template.usercenterUrl +
            "index.html?tenantId=" +
            this.webinarInfo.tenantId +
            "&schemaId=" +
            this.webinarInfo.schemaId +
            "&memberFormId=" +
            this.webinarInfo.registrationFormId,
          true
        )
        .subscribe(res => {
          window.open(res);
        });
    },
    questionary() {
      $subscriber.emit("showQuestion", "shoudong");
    },
    openAd() {
      this.showAd = true;
      $subscriber.emit("showWapshowAd");
    },
    scrollTop() {
      const box = document.querySelector(".meeting-info");
      box.scrollTo({ top: 0, behavior: "smooth" });
    }
  },

  created() {}
};
</script>
